import React from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import { useSelector } from 'react-redux';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import { getLoyaltyTerms } from 'selectors/appSelectors';
import LoadingWidget from 'components/LoadingWidget';

const LoyaltyTermsConditionsModal = () => {
  const loyaltyTerms = useSelector((state) => getLoyaltyTerms(state));

  return (
    <Modal
      modalKey={MODAL.LOYALTY_TERMS_AND_CONDITIONS}
      header={i18n('alamo_insider_terms_conditions')}
      theme={MODAL_THEMES.WHITE}
    >
      {loyaltyTerms ? (
        <>
          <div
            id={`${MODAL.LOYALTY_TERMS_AND_CONDITIONS}_desc`}
            className='modal-print__container modal-themed__paragraph'
          >
            <div dangerouslySetInnerHTML={sanitize(loyaltyTerms)} />
          </div>
        </>
      ) : (
        <LoadingWidget />
      )}
    </Modal>
  );
};

export default LoyaltyTermsConditionsModal;
